module.exports = __webpack_public_path__ + "static/img/team_title1.45a311b8.png";